import { useState, useEffect } from 'react';

/**
 * Custom hook to handle background configuration fetching and management
 */
const useBackgroundConfig = (bgId, bg_id) => {
    const [bgConfig, setBgConfig] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchBgConfig = async (backgroundId) => {
        if (!backgroundId) return null;
        
        setLoading(true);
        setError(null);
        
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASEURL_API_SPYNE}/3d/api/v1/bg/getById?bg_id=${backgroundId}`
            );
            
            if (!response.ok) {
                throw new Error(`Failed to fetch background config: ${response.statusText}`);
            }
            
            const data = await response.json();
            const config = data?.data?.config?.config;
            setBgConfig(config);
            return config;
        } catch (err) {
            console.error('Error fetching background config:', err);
            setError(err.message);
            return null;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const backgroundId = bg_id || bgId;
        if (backgroundId) {
            fetchBgConfig(backgroundId);
        } else {
            setBgConfig(null);
        }
    }, [bg_id, bgId]);

    return {
        bgConfig,
        loading,
        error,
        refetch: () => fetchBgConfig(bg_id || bgId)
    };
};

export default useBackgroundConfig; 